// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@vanmeter/XDL/constants";
import Close from "@vanmeter/XDL/Icons/IconClose";
import AlertError from "@vanmeter/XDL/Icons/IconNotificationError";
import AlertInfo from "@vanmeter/XDL/Icons/IconNotificationInfo";
import AlertSuccess from "@vanmeter/XDL/Icons/IconNotificationSuccess";
import AlertWarning from "@vanmeter/XDL/Icons/IconNotificationWarning";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color, hideElementOnPrint } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            css: css`
                padding: 0;
                &:hover ${IconWrapper} {
                    color: ${color("common.ui15")};
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 16,
            color: "common.ui5",
            css: css`
                width: 12px;
            `,
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-top: 2px;
                margin-right: 8px;
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            color: "text",
            css: css`
                &,
                ${TypographyStyle} {
                    font-size: ${fontConfig.small.size}px;
                    line-height: ${fontConfig.small.lineHeight};
                    letter-spacing: 0;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                border-radius: 2px;
                padding: 8px 12px;
                justify-content: space-between;
                align-items: baseline;
                gap: 8px;
                ${hideElementOnPrint}
            `,
            toastBody: css`
                align-items: flex-start;
                &&& {
                    margin: 0;
                }
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
